export default function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/nonIterableRest.js
// module id = 791
// module chunks = 2